module.exports = __webpack_public_path__ + "static/media/tile-1s-178x15px.0d28ed19.svg";